import { render, staticRenderFns } from "./CommodityCard2.vue?vue&type=template&id=deecff32&scoped=true&"
import script from "./CommodityCard2.vue?vue&type=script&lang=js&"
export * from "./CommodityCard2.vue?vue&type=script&lang=js&"
import style0 from "./CommodityCard2.vue?vue&type=style&index=0&id=deecff32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deecff32",
  null
  
)

export default component.exports